import { Endpoints } from '@/core/models/endpoints.interface';

export const CASE_FILES_OVERVIEW_ENDPOINTS: Pick<Endpoints, 'GET_ALL'> = {
   GET_ALL: () => `/case-files-overview`,
};
